<template>
  <div class="retention-wrapper">
    <div class="section-title">
      <div class="left">
        <div>
          <i class="el-icon-tickets"></i>
          <span class="title-name">留货单列表</span>
          <br />
          <span class="title-desc">{{ sortText }}</span>
        </div>
      </div>
      <div class="right">
        <el-button
          @click="addRetention"
          size="small"
          icon="el-icon-plus"
          v-if="checkPermission(['RESERVE_USER', 'RESERVE_ADMIN'])"
          >新增</el-button
        >
      </div>
    </div>
    <div class="retention-table-wrapper comon-table-style">
      <div class="table-tool-box hidden-sm-and-down">
        <div class="tool-item">
          <span class="tool-label">留货单号:</span>
          <span class="tool-content">
            <el-input
              style="width: 100%"
              v-model="filterorder"
              clearable
              placeholder="留货单号"
            ></el-input>
          </span>
        </div>
        <div class="tool-item">
          <span class="tool-label">客户名称:</span>
          <el-select
            v-model="tableFilters.clientName"
            style="width: 100%"
            filterable
            clearable
            placeholder="客户名称"
            @change="filterSearch"
          >
            <template v-for="(item, index) in clientNames">
              <el-option
                :label="item.text"
                :value="item.value"
                :key="index"
              ></el-option>
            </template>
          </el-select>
          <!-- <span class="tool-content"><el-input style="width:100%" v-model="tableFilters.clientName" placeholder="客户名称" @change="filterSearch"></el-input></span> -->
        </div>
        <div class="tool-item">
          <span class="tool-label">受理状态:</span>
          <span class="tool-content">
            <el-select
              v-model="tableFilters.orderStatus"
              style="width: 100%"
              filterable
              clearable
              placeholder="受理状态"
              @change="orderStatusChange"
            >
              <template v-for="(item, index) in approvalStatus">
                <el-option
                  :label="item.text"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </template>
            </el-select>
          </span>
        </div>
        <div class="tool-item" style="flex: 2">
          <span class="tool-label">时间起始:</span>
          <span class="tool-content">
            <el-date-picker
              style="width: 100%"
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </span>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :data="tableData"
        :default-sort="{ prop: sortedBy, order: listDirection }"
        @sort-change="onTableSortChange"
        border
        class="retention-table"
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="单号"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.id">{{
              scope.row.id
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="clientName"
          label="客户名称"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.clientName">{{
              scope.row.clientName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="submitTimestamp"
          label="单据日期"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.submitTimestamp | date }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reserveTo"
          label="留货截止日期"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.reserveTo | date }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="availableStatus"
          align="center"
          label="单据状况"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="remark"
          align="center"
          label="备注"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="split-text" :title="scope.row.remark">{{
              scope.row.remark
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="approvalStatus"
          align="center"
          label="受理状态"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="control"
          align="center"
          label="操作"
          fixed="right"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              type="warning"
              class="control-btn"
              size="small"
              @click="showDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagenation-wrapper">
        <!-- pc端显示 -->
        <el-pagination
          class="pagenation hidden-xs-only"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page + 1"
          :page-sizes="[10, 20, 40, 60, 80]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSizes"
        ></el-pagination>
        <!-- 移动端显示 -->
        <el-pagination
          class="pagenation pagenation-samll hidden-md-only"
          small
          :current-page="page + 1"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="totalSizes"
        ></el-pagination>
      </div>
    </div>
    <transition
      :duration="1000"
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
    >
      <keep-alive>
        <right-draw v-if="isRightToolBar">
          <div class="table-tool-box">
            <div class="tool-item">
              <span class="tool-label">开始日期:</span>
              <span class="tool-content">
                <el-date-picker
                  v-model="datePicker.start"
                  type="date"
                  :picker-options="dateStartOptions"
                  placeholder="选择起始日期"
                ></el-date-picker>
              </span>
            </div>
            <div class="tool-item">
              <span class="tool-label">结束日期:</span>
              <span class="tool-content">
                <el-date-picker
                  v-model="datePicker.end"
                  type="date"
                  :picker-options="dateEndOptions"
                  placeholder="选择结束日期"
                ></el-date-picker>
              </span>
            </div>
            <div class="tool-item">
              <span class="tool-label">单号:</span>
              <span class="tool-content">
                <el-input
                  v-model="tableFilters.order"
                  placeholder="产品码"
                ></el-input>
              </span>
            </div>
            <div class="table-search" @click="filterSearch">搜索</div>
          </div>
        </right-draw>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import commonMenu from "@/components/menu";
import rightDraw from "@/layout/components/rightDraw";
import { mapMutations } from "vuex";
import { throttle } from "@/utils/app";
import { checkPermission } from "@/utils/auth";
import { getOrderNameCn, getOrderType } from "@/utils/app";
import qs from "qs";
export default {
  name: "retention",
  components: {
    commonMenu,
    rightDraw,
  },
  data() {
    let shortcuts = [
      {
        text: "今天",
        onClick(picker) {
          picker.$emit("pick", new Date());
        },
      },
      {
        text: "昨天",
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit("pick", date);
        },
      },
      {
        text: "一周前",
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", date);
        },
      },
    ];
    return {
      size: 10,
      page: 0,
      totalPages: 0,
      totalSizes: 0,
      tableLoading: false,
      clientNames: [],
      approvalStatus: [],
      tableData: [],
      filterorder: "",
      sortedBy: "submitTimestamp,desc",
      sortText: `按照默认 留货单提交时间 倒序排序`,
      listDirection: "descending",
      tableFilters: {
        clientName: "",
        orderStatus: "",
      },
      dateRange: null,
      datePicker: {
        start: "",
        end: "",
      },
      dateStartOptions: {
        disabledDate: (time) => {
          if (this.datePicker.end != "") {
            return (
              time.getTime() > Date.now() ||
              time.getTime() > this.datePicker.end
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
        shortcuts: shortcuts,
      },
      dateEndOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.datePicker.start ||
            time.getTime() > Date.now()
          );
        },
        shortcuts: shortcuts,
      },
    };
  },
  computed: {
    isRightToolBar() {
      return this.$store.state.app.rightToolBar;
    },
    isMobile() {
      return this.$store.state.app.isMobileMode;
    },
  },
  watch: {
    dateRange(val) {
      this.page = 0;
      this.getTableData();
    },
    filterorder(val) {
      throttle(() => {
        this.filterSearch();
      }, 500)();
    },
  },
  created() {
    this.getTableData();
    this.getFilterOptions();
  },
  methods: {
    getOrderNameCn,
    getOrderType,
    checkPermission,
    ...mapMutations({
      ToggleMobileSideBar: "app/ToggleMobileSideBar",
      ToggleToolBar: "app/ToggleToolBar",
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar",
    }),
    filterDataParams() {
      return {
        size: this.size,
        page: this.page,
        sort: this.sortedBy,
        id: this.filterorder,
        clientName: this.tableFilters.clientName,
        approvalStatus: this.tableFilters.orderStatus,
      };
    },
    getFilterOptions() {
      this.$api
        .get(`/reserves/filter?${qs.stringify(this.filterDataParams())}`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.approvalStatus = [];
            this.clientNames = [];
            res.data.approvalStatus.forEach((ele) => {
              this.approvalStatus.push({
                label: ele,
                value: ele,
              });
            });
            res.data.clientNames.forEach((ele) => {
              this.clientNames.push({
                label: ele,
                value: ele,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },

    getTableData() {
      this.tableLoading = true;
      let startDate =
        this.dateRange !== null
          ? new Date(this.dateRange[0]).toISOString()
          : "";
      let endDate =
        this.dateRange !== null
          ? new Date(this.dateRange[1]).toISOString()
          : "";
      this.$api
        .get(
          `/reserves?submitTimestamp=${startDate}&submitTimestamp=${endDate}&${qs.stringify(
            this.filterDataParams()
          )}`
        )
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.tableData = res.data.content;
            this.totalPages = res.data.totalPages;
            this.totalSizes = res.data.totalElements;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    filterSearch() {
      // 移动端模式下需要关闭侧边栏
      if (this.isMobile) {
        this.CloseToolBar();
      }
      this.page = 0;
      this.getTableData();
      this.getFilterOptions();
    },
    addRetention() {
      this.$router.push({
        path: "/retention/add",
        query: {
          type: "add",
          id: "",
        },
      });
    },
    getSortName(prop) {
      let group = [
        {
          key: "id",
          name: "单号",
        },
        {
          key: "clientName",
          name: "客户名称",
        },
        {
          key: "submitTimestamp",
          name: "单据日期",
        },
        {
          key: "reserveTo",
          name: "留货截止日期",
        },
        {
          key: "availableStatus",
          name: "单据状况",
        },
        {
          key: "remark",
          name: "备注",
        },
        {
          key: "approvalStatus",
          name: "受理状态",
        },
      ];
      return group.find((item) => item.key == prop).name;
    },
    onTableSortChange({ column, prop, order }) {
      this.listDirection = order;
      if (order === null) {
        this.sortedBy = null;
        this.sortText = `按照默认 留货单提交时间 倒序排序`;
      } else {
        this.sortedBy = `${prop},${getOrderType(order)}`;
        this.sortText = `按照 ${this.getSortName(prop)} ${this.getOrderNameCn(
          order
        )} 排序`;
      }
      this.reFresh();
    },
    reFresh() {
      this.page = 0;
      this.getTableData();
    },
    orderStatusChange(val) {
      this.reFresh();
    },
    handleSizeChange(val) {
      this.size = val;
      this.reFresh();
    },
    handleCurrentChange(val) {
      this.page = val - 1;
      this.getTableData();
    },
    handelEdit(item) {
      this.$router.push({
        path: "/retention/add",
        query: {
          type: "edit",
          id: item.id,
        },
      });
    },
    handelDelete(item) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api
          .delete(`/reserves/${item.id}`)
          .then((res) => {
            if (res.status === 200 || res.status === 204) {
              this.page = 0;
              this.getTableData();
              this.getFilterOptions();
              this.$message.success("删除成功");
            }
          })
          .catch((err) => {
            console.log(err.response);
            this.$message.error(err.response.data.message);
          });
      });
    },
    showDetail(item) {
      this.$router.push({
        path: "/retention/detail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.retention-wrapper {
  overflow: hidden;
  .retention-table-wrapper {
    width: 100%;
    padding-top: 30px;
    .table-tool-box {
      box-sizing: border-box;
      position: relative;
      margin-top: 0;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .tool-item {
        box-sizing: border-box;
        padding: 0 10px 0 0;
        flex: 1;
        max-width: 300px;
        display: flex;
        text-align: left;
        line-height: 40px;
        box-sizing: border-box;
        font-size: 0;
        &:last-child {
          padding: 0;
        }
        .tool-label {
          flex: 60px 0 0;
          width: 60px;
          text-align: left;
          font-size: 14px;
          font-weight: 450;
          color: #333;
          margin-right: 8px;
        }
        .tool-content {
          flex: 1;
          font-size: 14px;
          color: #333;
        }
      }
      .table-search {
        position: absolute;
        right: 0;
        bottom: 2px;
        width: 50px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        color: #242424;
        border: 1px solid #929292;
        display: inline-block;
        transition: all 0.3s linear;
        &:hover {
          background-color: $theme_color;
          border: 1px solid $theme_color;
          color: #242424;
          cursor: pointer;
        }
      }
    }
    .retention-table {
      border: 1px solid #dbdbdb;
      .control-btn {
        margin: 5px auto;
        color: #333;
        background-color: $theme_color;
        border-color: $theme_color;
      }
      .split-text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 55px;
    text-align: left;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .right {
      flex: auto;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
    .title-desc {
      font-size: 14px;
      color: #989898;
    }
  }
}
@media screen and(max-width:992px) {
  .retention-wrapper {
    padding: 0px 0px 20px 0px;
    .right {
      .retention-table-wrapper {
        padding: 0;
      }
    }
    .table-tool-box {
      display: block;
      .tool-item {
        width: 100%;
        padding: 10px 0;
        .tool-label {
          display: block;
          margin-bottom: 5px;
          color: #fff;
          text-align: left;
        }
        .tool-content {
          display: block;
          font-size: 14px;
          color: #333;
          .el-select {
            width: 100%;
          }
        }
      }
      .table-search {
        width: 100%;
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        text-align: center;
        color: #333;
        background-color: $theme_color;
        display: block;
        margin-top: 12px;
        transition: all 0.3s linear;
      }
    }
  }
}
</style>
<style lang="scss">
.retention-wrapper {
  .table-tool-box {
    .el-input__inner {
      border: none;
      border-radius: 0px;
    }
  }
  .pagenation-wrapper {
    // 页码列表的前后的按钮
    .el-pagination button {
      background-color: transparent;
    }
    .el-pagination button:disabled {
      background-color: transparent;
    }
    .el-pagination button:hover {
      color: #fff;
      background-color: #4c4948;
    }
    // 可选的页码列表
    .el-pager li {
      background-color: transparent;
    }
    .el-pager li:hover {
      color: #fff;
      background-color: #4c4948;
    }
    .el-pager li.active {
      color: #fff;
      background-color: #4c4948;
      cursor: default;
    }
    // 手动输入页数的输入框
    .el-pagination__editor.el-input .el-input__inner {
      background-color: transparent;
    }
    // 选择多少条每页的按钮
    .el-pagination .el-select .el-input .el-input__inner {
      background-color: transparent;
    }
  }
}
</style>



